import React, { useState } from 'react';
import { LoginForm } from './LoginForm';
import { CreateAccount } from './CreateAccount';
import { CreateAccountConfirm } from './CreateAccountConfirm';
import { ForgotUsername } from './ForgotUsername';

interface SignInProps {
  onSignIn: (username: string) => Promise<void>;
  onSignInIdp: (email: string) => Promise<void>;
}

enum LoginView {
  LOGIN = 'login',
  CREATE_ACCOUNT = 'create_account',
  CREATE_ACCOUNT_CONFIRM = 'create_account_confirm',
  FORGOT_USERNAME = 'forgot_username',
}

export const SignIn: React.VFC<SignInProps> = ({ onSignIn, onSignInIdp }) => {
  const [loginView, setLoginView] = useState<LoginView>(LoginView.LOGIN);

  const switchToSignin = () => {
    setLoginView(LoginView.LOGIN);
  };

  const switchToCreateAccount = () => {
    setLoginView(LoginView.CREATE_ACCOUNT);
  };

  const switchToForgotUsername = () => {
    setLoginView(LoginView.FORGOT_USERNAME);
  };

  const switchToCreateAccountConfirm = () => {
    setLoginView(LoginView.CREATE_ACCOUNT_CONFIRM);
  };
  if (loginView === LoginView.LOGIN) {
    return (
      <LoginForm
        onSignIn={onSignIn}
        onSignInIdp={onSignInIdp}
        switchToCreateAccount={switchToCreateAccount}
        switchToForgotUsername={switchToForgotUsername}
      />
    );
  }
  if (loginView === LoginView.CREATE_ACCOUNT) {
    return (
      <CreateAccount switchToLocalSignin={switchToSignin} switchToCreateAccountConfirm={switchToCreateAccountConfirm} />
    );
  }
  if (loginView === LoginView.FORGOT_USERNAME) {
    return <ForgotUsername switchToLocalSignin={switchToSignin} />;
  }
  return <CreateAccountConfirm switchToLocalSignin={switchToSignin} />;
};
